import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { Cstpis } from '../model/cstpis.model';

@Injectable()
export class CstPisService extends EntityService<Cstpis> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'cstpis',
      pluralBaseEntityEndPoint: 'cstpiss',
      urlBackend: configService.backendURL
    });
  }
}
